module.exports = __webpack_public_path__ + "1.4.15-unryo/img/inject.583894cd.jpg";